<template>
  <div class="wrapper">
    <spread :Index="Index"></spread>
    <Menu ref="Menu"></Menu>
    <div class="top flex jc-sb">
      <div @click="$refs.Menu.show = true" class="menu wow fadeInLeft" data-wow-duration="1.5s" data-wow-delay="7s"></div>
      <div class="logo-sologen wow fadeInRight" data-wow-duration="1.5s" data-wow-delay="7s"></div>
    </div>
    <div class="xr wow fadeInLeft" data-wow-duration="2s" data-wow-delay="7s"></div>
  </div>
</template>

<script>
import spread from "./spread";
import Menu from "./menu";
import wx from 'weixin-js-sdk'
export default {
  components: { spread, Menu },
  props: {},
  data() {
    return {
      timer: null,
      Index: 0,
      circulate: 0
    }
  },
  watch: {},
  computed: {},
  methods: {},
  created() {



  },
  mounted() {
    wx.ready(() => {
      var obj = {
        title: 'WANS｜品牌互动营销案例精选', // 分享标题
        desc: '历史不可复制，破局者得以生存', // 分享描述
        link: 'https://case.chinawans.com/#/index', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: 'http://case.chinawans.com/img/share.jpg', // 分享图标
        success: function () {
          // 设置成功
        }
      }
      // wx.hideOptionMenu();
      wx.updateAppMessageShareData(obj)
      wx.updateTimelineShareData(obj)
    })
    if (!sessionStorage.getItem('loading')) {
      sessionStorage.setItem('loading', 1)
      this.timer = setInterval(() => {
        if (this.Index == 148) {
          clearInterval(this.timer)
          this.timer = setInterval(() => {
            if (this.Index == 261) {
              this.Index = 148
              this.circulate++
            } else {
              this.Index++;
            }
          }, 50)
        } else {
          this.Index++;
        }
        // if (this.circulate == 0 && this.Index == 210) {
        //   this.$refs.Menu.show = true
        // }
      }, 45);
      this.$wow('wow');
    } else {
      this.Index = 148
      this.timer = setInterval(() => {
        if (this.Index == 261) {
          this.Index = 148
        } else {
          this.Index++;
        }
      }, 50);
    }
  },
  destroyed() {
    clearInterval(this.timer);
  },
}
</script>
<style scoped>
.wrapper {
  position: relative;
  height: 100vh;
}

.top {
  position: relative;
  z-index: 1;
}

.menu {
  margin: .45rem;
  width: 1.03rem;
  height: .33rem;
  background-image: url(~@/assets/images/menu.png);
  background-size: 100% 100%;
}

.logo-sologen {
  width: 3.59rem;
  height: 4.29rem;
  margin-top: .1rem;
  background-image: url(~@/assets/images/logo+sologen.png);
  background-size: 100% 100%;
}

.xr {
  position: absolute;
  left: .45rem;
  bottom: .45rem;
  z-index: 1;
  width: .36rem;
  height: .52rem;
  background-image: url(~@/assets/images/xr.png);
  background-size: 100% 100%;
}
</style>